import Swiper from 'swiper';

console.log('tu');
console.log(document.querySelector('.product-gallery'));

if (document.querySelector('.product-gallery')) {
    let productGallery = new Swiper('.product-gallery', {
        loop: false,
        slidesPerView: 3,
        spaceBetween: 20,
        direction: "horizontal",
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                direction: "vertical",
            }
        },
    });

    console.log(productGallery);
}
